import React from "react";
import "../Assets/Css/security.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import aboutsecurity from "../Assets/Images/aboutsecurity.avif";
import ctasecureimg from "../Assets/Images/securityctaimg.avif";
import securitySitesImg from "../Assets/Images/TollPlazas.avif";
import securityPersonnelImg from "../Assets/Images/securityPersonnelImg.jpg";
import surveillanceSystemsImg from "../Assets/Images/Electronicsecurity.avif";
import monitoringImg from "../Assets/Images/monitoringImg.avif";
import housekeepingServicesImg from "../Assets/Images/housekeepingservice2.jpg";
import housekeepingStaffImg from "../Assets/Images/housekeepingservice1.jpg";
import cleanSafeEnvImg from "../Assets/Images/cleanSafeEnvImg.avif";
import operationalEfficiencyImg from "../Assets/Images/operationalEfficiencyImg.avif";
import { Helmet } from "react-helmet";

export default function SecurityServices() {
  const testimonials = [
    {
      message:
        "Outstanding security services! The team is professional, vigilant, and reliable. We feel safe and well-protected around the clock.",
      author: "Operations Head",
    },
    {
      message:
        "Excellent surveillance solutions. The CCTV systems are high-quality, and the installation process was smooth and efficient.",
      author: "Chief Admin Officer",
    },
    {
      message:
        "The event security provided was top-notch — professional, responsive, and well-organized throughout the event.",
      author: "Project Director",
    },
  ];

  const services = [
    {
      title: "Security Services for Toll Plazas and Industrial Sites",
      description:
        "Tailored security services to protect toll plazas, industrial sites, and other critical infrastructures.",
      image: securitySitesImg,
    },
    {
      title: "Deployment of Well-Trained Security Personnel",
      description:
        "Ensuring safety through the deployment of well-trained security personnel.",
      image: securityPersonnelImg,
    },
    {
      title: "Advanced Surveillance Systems",
      description:
        "Use of advanced surveillance systems to monitor and secure facilities.",
      image: surveillanceSystemsImg,
    },

    {
      title: "Activity Monitoring and Incident Prevention",
      description:
        "Monitoring activities to prevent unauthorized entry or incidents.",
      image: monitoringImg,
    },
    {
      title: "Comprehensive Housekeeping Services",
      description:
        "Maintaining cleanliness and hygiene standards across facilities.",
      image: housekeepingServicesImg,
    },
    {
      title: "Skilled Housekeeping Staff",
      description:
        "A team of skilled housekeeping staff ensuring clean, organized, and safe operational areas.",
      image: housekeepingStaffImg,
    },
    {
      title: "Clean and Safe Environments",
      description:
        "Ensuring toll plazas, offices, and other areas remain safe and well-maintained for employees and visitors.",
      image: cleanSafeEnvImg,
    },
    {
      title: "Enhanced Operational Efficiency",
      description:
        "Combining security and housekeeping to create a secure and efficient environment that enhances customer satisfaction.",
      image: operationalEfficiencyImg,
    },
  ];

  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        <title>
          Security & Housekeeping Services | Samashree Enterprises Pvt. Ltd.
        </title>
        <meta
          name="description"
          content="Samashree Enterprises offers professional security services for toll plazas and industrial sites, and reliable housekeeping solutions to maintain hygiene and operational efficiency."
        />
        <meta
          name="keywords"
          content="security services, housekeeping services, toll plaza security, industrial site protection, surveillance systems, professional cleaning services, Samashree Enterprises"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.samashreeenterprises.com/security-housekeeping-services"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Security & Housekeeping Services | Samashree Enterprises"
        />
        <meta
          property="og:description"
          content="Trusted experts in providing professional security and housekeeping services for toll plazas, industrial sites, and operational offices."
        />
        <meta
          property="og:url"
          content="https://www.samashreeenterprises.com/security-housekeeping-services"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.samashreeenterprises.com/images/security-housekeeping-banner.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Security & Housekeeping Services | Samashree Enterprises"
        />
        <meta
          name="twitter:description"
          content="High-quality security personnel and skilled housekeeping services ensuring clean, safe, and secure facilities."
        />
        <meta
          name="twitter:image"
          content="https://www.samashreeenterprises.com/images/security-housekeeping-banner.jpg"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section3">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Security & Housekeeping Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Trusted experts in Security & Housekeeping Services
          </p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up">
            Get in Touch
          </a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row className="">
            <Col
              md={6}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src={aboutsecurity}
                alt="About Security Services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={6}>
              <h2 className="page-title text-center" data-aos="fade-up">
                Overview
              </h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                At <strong>Samashree Enterprises Pvt. Ltd.</strong>, ., we
                provide reliable and professional security and housekeeping
                services to ensure the smooth and secure operation of
                facilities.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                Our security services are tailored to protect toll plazas,
                industrial sites, and other critical infrastructures, ensuring
                safety through the deployment of well-trained security personnel
                and advanced surveillance systems. We implement strict security
                protocols to safeguard assets, manage access control, and
                monitor activities to prevent unauthorized entry or incidents.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                In addition to security, our comprehensive housekeeping services
                maintain cleanliness and hygiene standards across facilities.
                Our team of skilled housekeeping staff ensures that toll plazas,
                offices, and other operational areas remain clean, organized,
                and safe for both employees and visitors. By combining efficient
                security measures with top-notch housekeeping practices, we
                create a secure, well-maintained environment that enhances
                operational efficiency and customer satisfaction.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <h2 className="page-title " data-aos="fade-up">
          Why Choose Us
        </h2>
        <section className="why-choose-us-bg py-5 bg-light">
          <Container>
            <Row className="gy-4 py-4 justify-content-center">
              <Col md={5} data-aos="zoom-in" data-aos-delay="100">
                <div className="feature-card1 h-100 p-4 shadow-sm d-flex flex-column">
                  <h5 style={{ color: "#28326E", textAlign: "center" }}>
                    Security Services:
                  </h5>
                  <ul className=" fs-5">
                    <li> Reliable and professional team </li>
                    <li> Well-trained security personnel </li>
                    <li> Advanced surveillance systems </li>
                  </ul>
                </div>
              </Col>
              <Col md={5} data-aos="zoom-in" data-aos-delay="200">
                <div className="feature-card1 h-100 p-4 shadow-sm d-flex flex-column">
                  <h5 style={{ color: "#28326E", textAlign: "center" }}>
                    Housekeeping Services:
                  </h5>
                  <ul className=" fs-5">
                    <li> Strict security protocols </li>
                    <li> Skilled housekeeping staff </li>
                    <li> Clean, organized, and safe facilities </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </section>

      {/* Services Section */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">
            Our Security & Housekeeping Services
          </h2>
          <Row>
            {services.map((service, index) => (
              <Col md={3} sm={12} className="mb-4" key={index}>
                <Card
                  className=" h-100 border-0 hover-shadow"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <Card.Img
                    variant="top"
                    src={service.image}
                    alt={service.title}
                    className="service-image"
                  />
                  <Card.Body>
                    <Card.Title style={{ color: "#008080" }}>
                      {service.title}
                    </Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col
              md={6}
              className="text-center text-md-start mb-3"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <h2>Looking for trusted security and housekeeping solutions?</h2>
              <p className="lead">
                Contact us today for a free consultation and quote.
              </p>
              <a href="/contact" className="btn-get">
                Get in Touch
              </a>
            </Col>

            <Col md={6}>
              <div
                className="d-flex justify-content-center"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card
                      className="p-4 mb-4 border-0 text-center"
                      data-aos="zoom-in"
                      data-aos-delay="100"
                    >
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: "italic" }}>
                        “{testimonial.message}”
                      </p>
                      <small className="text-muted">
                        — {testimonial.author}
                      </small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
